// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__yV7rK","rootSmall":"AddTileButton_rootSmall__1q0j9"};